import { useMemo } from 'react';

import { StatType } from 'services/stats';
import useStats from 'hooks/useStats';

import { timeFormat } from 'config/common';
import { formatDate } from 'helpers/date';

const useIndividualsLive = (locationId) => {
  const liveStats = useStats(StatType.employeesLive, {
    location_id: locationId,
  }, {
    initialStats: {
      doors: [],
      summary: {},
    },
    autoFetch: true,
    refreshInterval: 180000,
  });

  const summary = useMemo(() => {
    const { summary = {} } = liveStats.state.stats;
    const lastUpdate = summary.last_update ? formatDate(new Date(summary.last_update), timeFormat, { tzOffset: 0 }) : null;
    
    return {
      totalIndividuals: summary.tot_employees,
      loadingIndividuals: summary.loading,
      unloadingIndividuals: summary.unloading,
      lastUpdate,
    };
  }, [liveStats.state.stats]);

  return {
    isLoading: liveStats.state.isLoading,
    summary,
    liveStats,
  };
};

export default useIndividualsLive;